module.exports = "pegasus/assets/theme2/small/1.jpg";